import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200px',
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  resizeFontTextField: {
    width: 255,
    '& .MuiInputBase-input': {
      fontSize: '14px',
    },
    '& .MuiInputLabel-formControl': {
      fontSize: '14px',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
  },
  defaultValueWidth: {
    width: '220px',
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  rowText: {
    color: theme.palette.black.main,
    fontSize: '13px',
  },
  actionIcon: {
    color: theme.palette.icon.main,
    height: '24px',
    width: '24px',
    cursor: 'pointer',
    marginRight: theme.spacing(3),
    '&.css-ptiqhd-MuiSvgIcon-root': {
      width: '20px',
      height: '20px',
    },
  },
  actionIconDisabled: {
    opacity: 0.3,
  },
  adminContainer: {
    padding: theme.spacing(4, 4, 0, 4),
    whiteSpace: 'nowrap',
  },
  labraPOContainer: {
    padding: theme.spacing(3, 0, 0, 0),
  },
  createOfferBtn: {
    marginLeft: 'auto',
    paddingRight: theme.spacing(3),
  },
  alignButton: {
    textAlign: 'right',
    marginBottom: '40px',
  },
  createOfferLink: {
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  withResaleAuthTab: {
    padding: theme.spacing(0),
  },
  marginTopSpace: {
    marginTop: theme.spacing(5),
  },
  toolTipView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownAndProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '24px',
  },
  verticalDivider: {
    width: '1px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '4px',
    background: theme.palette.dividerV2.main,
  },
  dropDownWidth: {
    width: '335px',
  },
}))
